import sessionStore from '@/session/sessionStore'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { RequestOperation } from '@/api/operations/models/request-operation'
import { store } from '@/store/store'
import { GridUtils } from '@/shared/util/grid-utils'

const createStatusFilterModel =
    status => ({
        'status': GridUtils.getSetFilterModel([status])
    })

const getFullTranslationKey = key => `component.studyRequest.sideBar.${key}`
export const getSideBarOptions = () => {
    const canViewAllRequests = sessionStore.hasOperationInAnyLaboratory(RequestOperation.READ_ALL)
    const canViewCenterRequests = canViewAllRequests || sessionStore.hasOperationInAnyLaboratory(RequestOperation.READ_CENTER)
    const canViewDepartmentRequests = canViewCenterRequests || sessionStore.hasOperationInAnyLaboratory(RequestOperation.READ_DEPARTMENT)
    const canViewMyRequests = canViewDepartmentRequests || sessionStore.hasOperationInAnyLaboratory(RequestOperation.READ_ONLY_MINE)
    const canViewOtherRequests = canViewAllRequests || canViewCenterRequests || canViewDepartmentRequests
    return {
        sideBarName: 'ExpandedSideBar',
        expanded: [
            {
                id: 'myRequests',
                label: getFullTranslationKey('myRequests'),
                icon: ['fal', 'file-alt'],
                hasChildren: true,
                hide: !canViewMyRequests,
                children: [
                    {
                        id: 'requestsWithApReportNotSeen',
                        label: getFullTranslationKey('unread'),
                        icon: ['fal', 'envelope-open-text'],
                        url: '/clinical/laboratories/requests/myRequests',
                        filterModel: createStatusFilterModel(REQUEST_STATES.COMPLETED.code),
                        externalFilterModel: {
                            combinedFilter: {
                                filterType: 'combined',
                                propertyKeyCondition1: 'apReportSeenByPetitioner',
                                condition1: {
                                    filterType: 'boolean',
                                    type: 'equals',
                                    filter: false
                                },
                                propertyKeyCondition2: 'apReportWithComplementarySeenByPetitioner',
                                condition2: {
                                    filterType: 'boolean',
                                    type: 'equals',
                                    filter: false
                                },
                                operator: 'OR'
                            },
                            'physicianPetitioner.id': GridUtils.getNumberFilterModel('equals', store.getters.userInformation?.petitioner?.id ?? null)
                        }
                    },
                    {
                        id: 'requestsWithPendingComplementaryValidation',
                        label: getFullTranslationKey('complementaries'),
                        icon: ['fal', 'layer-plus'],
                        externalFilterModel: {
                            caseSituation: GridUtils.getTextFilterModel('equals', 'PENDING_COMPLEMENTARY'),
                            apReportSeenByPetitioner: {
                                filterType: 'boolean',
                                type: 'equals',
                                filter: true
                            }
                        }
                    },
                    {
                        id: 'requestsInDraftState',
                        label: getFullTranslationKey('draft'),
                        icon: ['fal', 'edit'],
                        url: '/clinical/laboratories/requests/myDrafts'
                    },
                    {
                        id: 'states',
                        label: 'global.statusP',
                        hasChildren: true,
                        icon: ['fal', 'tags'],
                        children: [
                            {
                                id: 'requested',
                                label: getFullTranslationKey('requested'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.REQUESTED.code)
                            },
                            {
                                id: 'registered',
                                label: getFullTranslationKey('registered'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.REGISTERED.code)
                            },
                            {
                                id: 'completed',
                                label: getFullTranslationKey('completed'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.COMPLETED.code)
                            },
                            {
                                id: 'requestsInLockState',
                                label: getFullTranslationKey('blocked'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.LOCKED.code)
                            },
                            {
                                id: 'returned',
                                label: getFullTranslationKey('returned'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.RETURNED.code)
                            },
                            {
                                id: 'canceled',
                                label: getFullTranslationKey('canceled'),
                                filterModel: createStatusFilterModel(REQUEST_STATES.CANCELED.code)
                            }
                        ]
                    },
                    {
                        id: 'dates',
                        label: 'global.dateTarget.createdRequests',
                        hasChildren: true,
                        icon: ['fal', 'calendar-alt'],
                        children: [
                            {
                                id: 'today',
                                label: getFullTranslationKey('today'),
                                externalFilterModel: {
                                    reqRequestDate: GridUtils.getTodayDateFilterModel()
                                }
                            },
                            {
                                id: 'thisWeek',
                                label: getFullTranslationKey('thisWeek'),
                                externalFilterModel: {
                                    reqRequestDate: GridUtils.getThisWeekDateFilterModel()
                                }
                            },
                            {
                                id: 'thisMonth',
                                label: getFullTranslationKey('thisMonth'),
                                externalFilterModel: {
                                    reqRequestDate: GridUtils.getThisMonthDateFilterModel()
                                }
                            }
                        ]
                    }
                ]
            },
            {
                id: 'otherRequests',
                label: getFullTranslationKey('otherRequests'),
                icon: ['fal', 'file-alt'],
                hasChildren: true,
                hide: !canViewOtherRequests,
                children: [
                    {
                        id: 'services',
                        label: getFullTranslationKey('services'),
                        icon: ['fal', 'clinic-medical'],
                        url: '/clinical/laboratories/requests/departmentRequests',
                        hide: !canViewDepartmentRequests
                    },
                    {
                        id: 'centers',
                        label: getFullTranslationKey('centers'),
                        icon: ['fal', 'hospital-alt'],
                        url: '/clinical/laboratories/requests/centerRequests',
                        hide: !canViewCenterRequests
                    },
                    {
                        id: 'allRequests',
                        label: getFullTranslationKey('all'),
                        icon: ['fal', 'list-ul'],
                        url: '/clinical/laboratories/requests/all',
                        hide: !canViewAllRequests
                    }
                ]
            }
        ],
        module: {
            icon: ['fal', 'file-medical'],
            name: 'global.requests'
        }
    }
}
